<template>
  <div>
    <v-card style="border-radius: 20px">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-spacer></v-spacer>
          <v-stepper-step :complete="e1 > 1" step="1">Still Here?</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">Know Departure</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3">Departure Date</v-stepper-step>
          <v-btn icon small top right fab @click="$store.commit('setStillHereDialogVisibility', false)"><v-icon>mdi-close</v-icon></v-btn>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="onboardingDialogCard" elevation="0">
              <v-card-subtitle class="onboardingDialogSubtitle">Long time..</v-card-subtitle>
              <v-card-title class="py-0">Are You Still in <br>{{$store.state.userData.currentStayLocation}}?</v-card-title>
            </v-card>
            <v-btn class="onboardingBtn" color="primary" @click="e1 = 2; isStillThere=false">No</v-btn>
            <v-btn class="onboardingBtn" color="primary" @click="e1 = 2; isStillThere=true">Yes</v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="onboardingDialogCard" elevation="0" style="margin-bottom: 0">
              <v-card-subtitle v-if="isStillThere" class="onboardingDialogSubtitle">That's Great!</v-card-subtitle>
              <v-card-subtitle v-else class="onboardingDialogSubtitle">Sorry to See You Go..</v-card-subtitle>
              <v-card-title style="word-break: break-word" class="pt-0" v-if="isStillThere">Know When You are Planning on Leaving?</v-card-title>
              <v-card-title class="pt-0" v-else>When Did You Leave?</v-card-title>
            </v-card>
            <v-date-picker v-model="departureDate" scrollable no-title></v-date-picker>
            <v-btn v-if="isStillThere" class="onboardingBtn" smaller color="primary" @click="dontKnow">Don't Know
              <v-icon right dark>
                mdi-human-handsup
              </v-icon>
            </v-btn>
            <v-btn v-else class="onboardingBtn" smaller color="primary" @click="updateStayEndedNoDate">Never Mind</v-btn>
            <div>
              <v-btn class="onboardingBtn" smaller color="primary" @click="e1 = 1">Back</v-btn>
              <v-btn class="onboardingBtn" smaller color="primary" @click="dateUpdateNext">Next</v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="onboardingDialogCard" elevation="0" style="margin-bottom: 0">
              <v-card-title style="padding-top: 0; word-break: break-word">Thanks For Letting Us Know!</v-card-title>
            </v-card>
            <v-btn class="onboardingBtn" color="primary" @click="$store.commit('setStillHereDialogVisibility', false)">Close</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <v-alert v-if="isStillThere" class="mx-5 missingDataAlert" transition="scroll-y-transition" dismissible v-model="missingDataAlert" type="error" dense origin="top" border="right">
      Let us know when you're leaving, or pick "Don't Know" if you are not sure yet.
    </v-alert>
    <v-alert v-else class="mx-5 missingDataAlert" transition="scroll-y-transition" dismissible v-model="missingDataAlert" type="error" dense origin="top" border="right">
      Let us know when you Left, or pick "Never Mind" if you prefer not to.
    </v-alert>

  </div>

</template>

<script>

import {allMixins} from "@/mixins/allMixins";
import {store} from "@/store";


export default {
  name: "StillHere",
  mixins: [allMixins],
  data() {
    return {
      e1: 1,
      autocompleteKey: 0,
      departureDate: null,
      isPublicStay: store.state.userData?.privacyDefault || true,
      missingDataAlert: false,
      isStillThere: false,
    }
  },
  methods: {
    async dateUpdateNext() {
      if (this.departureDate) {
        let updateTense = this.isStillThere ? 'present' : 'past'
        await this.updateStayDepartureDate(store.state.userData.currentStayId, this.departureDate, updateTense)
        await store.dispatch('getMyLocations')
        this.e1 = 3
      } else {
        this.missingDataAlert = true
      }
    },
    async dontKnow() {
      this.departureDate = null
      let updateTense = this.isStillThere ? 'present' : 'past'
      await this.updateStayDepartureDate(store.state.userData.currentStayId, this.departureDate, updateTense)
      this.e1 = 3
    },
    async updateStayEndedNoDate() {
      await this.updateStayDepartureDate(store.state.userData.currentStayId, null, 'past')
      await store.dispatch('getMyLocations')
      this.e1 = 3
    },
  }
}

</script>

<style>
.missingDataAlert {
  position: absolute;
  width: 80vw;
  left: 5vw;
  top: 5vh;
}

.onboardingDialogCard {
  padding-top: 0px;
  margin-bottom: 40px;
  text-align-last: center;
}

.onboardingDialogSubtitle {
  padding: 0;
}

.onboardingBtn {
  margin: 12px;
  text-transform: capitalize;
  font-weight: bold;
}
</style>
